import React           from 'react';
import { appsType }    from '../../types';
import colors          from '../../utils/colors'
import { words }       from '../../utils/dictionary'
import { makeStyles }  from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
    root: {
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'space-around',
      flexFlow:        'column',
    },
    innerBig: {
      height:          370,
      width:           270,
      borderRadius:    '1em',
      border:          `1px solid #CCC`,
      transition:      'height 0.4s, width 0.4s, transform 1.1s, opacity 1.5s',
      cursor:          'pointer',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'flex-end',
      flexFlow:        'column',
      '&:hover': {
        height: 445,
        width:  295,
      }
    },
    innerSmall: {
      height:          270,
      width:           270,
      borderRadius:    '1em',
      border:          `1px solid #CCC`,
      transition:      'height 0.4s, width 0.4s, transform 1.1s, opacity 1.5s',
      cursor:          'pointer',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'flex-end',
      flexFlow:        'column',
      '&:hover': {
        height: 295,
        width:  295,
      }
    },
    image: {
      height:             '60%',
      width:              '90%',
      backgroundPosition: 'center',
      backgroundSize:     'contain',
      backgroundRepeat:   'no-repeat'
  },
  name: {
    height:         '30%',
    width:          '90%',
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center',
    textAlign:      'center'
  },
  studentsInfoContainer: {
   // height:         150,
    height:         100,
    width:          '100%',
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'space-evenly',
    textAlign:      'center',
    flexFlow:       'column',
    transition:     'transform 1.1s, opacity 1.5s',
  },
  studentsInfoTitle: {
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'space-evenly',
    textAlign:      'center',
  },
  button: {
   // height:          45,
    height:          30,
    width:           200,
    display:         'flex',
    alignItems:      'center',
    justifyContent:  'center',
    textAlign:       'center',
    borderRadius:    '0.5em',
  },
  topicsButton:{
    height:          30,
    width:           200,
    display:         'flex',
    alignItems:      'center',
    justifyContent:  'center',
    textAlign:       'center',
    borderRadius:    '0.5em',
    cursor:          'pointer',
    color:           '#FFF',
    backgroundColor: colors.dark,
    border:          `1px solid transparent `,
    transition:     'height 0.6s, margin 0.6s, width 0.6s, transform 0.6s, opacity 0.6s',
    '&:hover': {
      backgroundColor: '#FFF',
      color:           colors.dark,
      border:          `1px solid ${ colors.dark }`,
    }

  }
}))

type UnitProps = {
  val:                    appsType;
  ind:                    number;
  variant:                string;
  lang:                   string;
  userRole:               string;
  handleAppClick:         (val: number) => void,
  handleStudentInfoClick: (val: string[]) => void;
}

const Unit: React.FC<UnitProps> = ({
  val,
  ind,
  variant,
  lang,
  userRole,
  handleAppClick,
  handleStudentInfoClick
}) => {

  const classes = useStyles();

  const [initialPos, setInitialPos]   = React.useState(false)
  const [buttonHover, setButtonHover] = React.useState(false)
  const [showTopics, setShowTopics]   = React.useState(false)

  React.useEffect(() => {
    setTimeout(() => {
      setInitialPos(true)
    },(ind + 1) * 100)
  },[ind])

  const [name, display, disableButton] = React.useMemo(() => {

    return [
       lang === 'heb' ? val.app : val.app_arabic,
       val.classes === +variant ? 'flex' : 'none',
       val.submissions === 0
    ]
  },[val, lang, variant])


  const handleTopicSelection = () => {
    setShowTopics(!showTopics)
  }


  return (
    <div
       className = { classes.root }
       style     = {{
         display: display,
         height:  userRole === 'teacher' ? 450 : 300
       }}
    >
         
         <div
            className = { ((userRole === 'teacher' && val.submissions && val.submissions > 0) || userRole !== 'teacher') ? classes.innerSmall : classes.innerBig }
           // onClick   = { () => handleAppClick(ind) }
            style     = {{
              transform: `translate(0px, ${ initialPos ? 0 : 100 }vh)`,
              opacity:   initialPos ? 1 : 0
            }}
         >
           <div
              className = { classes.image }
              onClick   = { () => handleAppClick(ind) }
              style     = {{
                backgroundImage: `url(${ `https://www.yisumatica.org.il/flash-upload/js/img/apps3/${ val.lesson_id }.JPG` })`
              }}
           />
           <div 
              className = { classes.name }
              onClick   = { () => handleAppClick(ind) }
           >
              { name }
           </div>
        </div>
        {
          userRole === 'teacher' && val.submissions > 0
          &&
          <div
             className = { classes.studentsInfoContainer }
             style     = {{
              transform: `translate(0px, ${ initialPos ? 0 : 100 }vh)`,
              opacity:   initialPos ? 1 : 0
            }}
          >
              <div
                dir       = 'rtl'
                className = { classes.studentsInfoTitle }
              >
                { `${ words['submissionNum'][lang] } : ${ val.submissions }` }
              </div>
              <div
                dir          = 'rtl'
                className    = { classes.button }
                onClick      = { () => { if (!disableButton) { handleStudentInfoClick([`${ val.lesson_id }`, val.app, val.app_arabic]) }}}
                onMouseEnter = { () => { if (!disableButton) { setButtonHover(true) }}}
                onMouseLeave = { () => { if (!disableButton) { setButtonHover(false) }}}
                style        = {{
                  opacity:         disableButton ? 0.5 : 1,
                  cursor:          disableButton ? 'default' : 'pointer',
                  color:           !buttonHover ? '#FFF' : colors.dark,
                  backgroundColor: !buttonHover ? colors.dark: '#FFF',
                  border:          `1px solid ${ buttonHover ? colors.dark : 'transparent' }`,
                }}
              >
                { words['showStudentInfo'][lang] }
              </div>
          </div>
        }
        {
               userRole === 'teacher' && variant === "2" && !!val.topics && !!val.topics.length 
               &&
               <div 
                   className = { classes.topicsButton }
                   onClick   = { handleTopicSelection }
                   style     = {{
                    flexFlow:       showTopics ? 'column' : undefined,
                    height:         showTopics ? 250 : undefined,
                    marginTop:      showTopics ? 25 : undefined,
                    marginBottom:   showTopics ? 25 : undefined,
                    width:          showTopics ? '90%' : undefined,
                    transform:      `translate(0px, ${ initialPos ? 0 : 100 }vh)`,
                    opacity:        initialPos ? 1 : 0
                   }}
                >
                  {
                    showTopics
                    &&
                    val.topics.split(',').map((val, ind) => {
                        return(
                          <div
                             key   = { `${ val }${ ind }` }
                             dir   = 'rtl' 
                             style = {{ margin: 4 }}
                          >
                            { val }
                          </div>
                        )
                    })
                  }
                  {
                    !showTopics
                    &&
                    `${ words['showTopics'][lang] }`
                  }
               </div>
           }
    </div>
  );
}

export default Unit;
